/** Who may do what on the desk — the role lists pages used to repeat inline. */
export const canEditJobs = (role) => role === 'owner' || role === 'office';

export const isKeeper = (role) =>
  role === 'owner' || role === 'office' || role === 'bookkeeper';

/** Who marks the contract's work done: the people who run it and build it. */
export const canRecordProgress = (role) =>
  role === 'owner' || role === 'office' || role === 'field';

/** Who records a bill or an expense: the keepers, and the crew who spend. */
export const canRecordExpense = (role) => isKeeper(role) || role === 'field';

/**
 * Who works a job — everyone but a viewer: adds to its notes log (phase 5a,
 * `add_job_note`) and adds, ticks off, edits and deletes its to-dos
 * (`add_task` …, 20260929000600).
 */
export const worksTheJob = (role) => isKeeper(role) || role === 'field';

export const canAddNote = worksTheJob;

/**
 * Who sees the job's prices (spec §4, Roles): everyone but the crew — so the
 * customer's page, which shows every price, is not theirs either (phase 5a).
 */
export const seesPrices = (role) => role !== 'field';

/** Costs and margins (spec §6.3, §6.7): the owner's alone. */
export const canSeeCosts = (role) => role === 'owner';

/** The books plan is the owner's to choose. */
export const canChoosePlan = (role) => role === 'owner';

/** The company page and the team (phase 3d §2, §3): the owner's alone. */
export const canManageCompany = (role) => role === 'owner';

/**
 * The owner: the role the join page cannot tell to "ask your owner to
 * remove you" (a solo owner has no one to ask, and a team never loses its
 * last owner).
 */
export const isOwner = (role) => role === 'owner';

const ROLE_LABEL = {
  owner: 'Owner',
  office: 'Office',
  bookkeeper: 'Bookkeeper',
  field: 'Field',
  viewer: 'Viewer',
};

/** A member role as a word; a role this map does not know reads as itself. */
export const roleLabel = (role) => ROLE_LABEL[role] || String(role ?? '');

/** Every role, as `{ value, label }` for a picker, in the order above. */
export const ROLE_OPTIONS = Object.entries(ROLE_LABEL).map(
  ([value, label]) => ({ value, label })
);
